<template>
    <div id="content">
        <loader v-if="loading"></loader>
        <div class="mt-3" v-else>
            <b-table small striped hover bordered :items="data" :fields="['city', 'category','level', 'startPrice', 'pricePerKm', 'minPrice', 'commission', 'action']">
                <template v-slot:cell(category)="data">
                    {{data.value.name}}
                </template>
                <template v-slot:cell(city)="data">
                    {{data.value.name}}
                </template>
                <template v-slot:cell(level)="data">
                    {{data.value.name}}
                </template>
                <template v-slot:cell(commission)="data">
                    %{{data.value}}
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="primary" v-b-modal="String(row.item.id)">Edit</b-button>

                    <b-modal :busy="saving" :id="String(row.item.id)" title="Update Pricing" @ok="() => update(row.item.id, form[row.index])" :disabled="saving">
                        <b-form @submit.prevent.stop="() => update(row.item.id, form[row.index])">
                            <b-form-group>
                                <b-form-input type="number" required placeholder="Start Price" v-model="form[row.index].startPrice"></b-form-input>
                            </b-form-group>
                            <b-form-group>
                                <b-form-input type="number" required placeholder="Price Per Km" v-model="form[row.index].pricePerKm"></b-form-input>
                            </b-form-group>
                            <b-form-group>
                                <b-form-input type="number" required placeholder="Min Price" v-model="form[row.index].minPrice"></b-form-input>
                            </b-form-group>
                            <b-form-group>
                                <b-form-input type="number" required placeholder="Commission" v-model="form[row.index].commission"></b-form-input>
                            </b-form-group>
                        </b-form>
                    </b-modal>

                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import GetTripPricing from '../../../store/actions/getTripPricing';
import UpdateTripPricing from '../../../store/actions/updateTripPricing';
import ContentLoader from '../../../components/ContentLoader';
import ShowError from "../../../helpers/showError";

  export default {
    name: 'TripPricing',
    components: {
      loader: ContentLoader
    },
    data() {
      return {
        data: [],
        saving: false,
        form: [],
        loading: true,
      }
    },
    created() {
      this.load();
    },
    methods: {
      async load(){
        try {
          this.loading = true;
          const result = await GetTripPricing();
          this.data = result;
          this.form = result;
        } catch (e) {
          ShowError(this, e);
        } finally {
          this.loading = false;
        }
      },
      async update(id, {minPrice, pricePerKm, startPrice, commission}){
        try {
          this.loading = true;
          await UpdateTripPricing(id, {minPrice: Number(minPrice), pricePerKm: Number(pricePerKm), startPrice: Number(startPrice), commission: Number(commission)});
          this.load();
        } catch (e) {
          ShowError(this, e);
        } finally {
          this.loading = false;
        }
      }
    }
  }
</script>
